import { CSSObject } from '@chakra-ui/react';

export const TabsContentContainer: CSSObject = {
  pt: '0',
};
